import { FORM_TRANSITION, INPUT_RESET } from '@/app/components/forms/styles';
import { cnva } from '@/app/utils/cnva';

/**
 * Input box wrapper including borders and outline behaviors.
 */
export const inputBoxStyled = cnva(
  [
    'relative border',
    FORM_TRANSITION,
    'before:rounded-10 before:pointer-events-none before:absolute before:-inset-0.75',
    'before:transition-border before:border-2 before:border-transparent',
  ],
  {
    variants: {
      theme: {
        light: [
          'bg-white',
          'border-gray-200 focus-within:border-gray-600 hover:border-gray-600',
          'focus-within:before:border-black/20 hover:before:border-black/20',
        ],
        dark: [
          'bg-gray-900',
          'border-gray-500 focus-within:border-gray-100 hover:border-gray-100',
          'focus-within:before:border-white/50 hover:before:border-white/50',
        ],
      },
      error: {
        true: 'border-crimson-500 hover:border-crimson-500 focus-within:border-crimson-500',
      },
      disabled: {
        true: 'pointer-events-none select-none',
      },
    },
    compoundVariants: [
      {
        disabled: true,
        theme: 'light',
        className: 'border-gray-200 bg-gray-50',
      },
      {
        disabled: true,
        theme: 'dark',
        className: 'border-gray-500 bg-gray-700',
      },
      {
        error: true,
        theme: 'light',
        className:
          'hover:before:border-crimson-500/25 focus-within:before:border-crimson-500/25',
      },
      {
        error: true,
        theme: 'dark',
        className:
          'hover:before:border-crimson-500/50 focus-within:before:border-crimson-500/50',
      },
    ],
  }
);

/**
 * Input field text styles.
 */
export const inputTextStyled = cnva(
  [
    INPUT_RESET,
    'text-body-1-fixed transition-color w-full placeholder:text-gray-400',
  ],
  {
    variants: {
      theme: {
        light: 'text-gray-900',
        dark: 'text-white',
      },
      disabled: {
        true: 'disabled:text-gray-400 disabled:opacity-100 disabled:[-webkit-text-fill-color:var(--color-gray-400)]',
      },
      error: {
        true: '',
      },
    },
  }
);

/**
 * Affix (prefix/suffix) text style inside input.
 */
export const inputAffixTextStyled = cnva(
  'text-body-1-fixed transition-color pointer-events-none select-none',
  {
    variants: {
      theme: {
        light: 'text-gray-400',
        dark: 'text-gray-400',
      },
      disabled: {
        true: 'text-gray-400',
      },
      error: {
        true: '',
      },
    },
  }
);

/**
 * Input icon styling
 */
export const inputIconStyled = cnva('transition-color pointer-events-none', {
  variants: {
    theme: {
      light:
        'text-gray-200 group-focus-within:text-gray-400 group-hover:text-gray-400',
      dark: 'text-gray-400 group-focus-within:text-gray-300 group-hover:text-gray-300',
    },
    error: {
      true: 'text-crimson-500 group-hover:text-crimson-500 group-focus-within:text-crimson-500',
    },
    disabled: {
      true: 'text-gray-300',
    },
  },
});

/**
 * Stepper button (up/down) inside numeric inputs.
 */
export const inputStepperButtonStyled = cnva(
  [INPUT_RESET, 'transition-color h-5 w-6 cursor-pointer'],
  {
    variants: {
      theme: {
        light: [
          'text-gray-200 focus-within:text-gray-800 hover:text-gray-800',
          'group-focus-within:text-gray-800 group-hover:text-gray-800',
        ],
        dark: [
          'text-gray-400 focus-within:text-gray-50 hover:text-gray-50',
          'group-focus-within:text-gray-50 group-hover:text-gray-50',
        ],
      },
      error: {
        true: [
          'text-crimson-500',
          'group-hover:text-crimson-500 group-focus-within:text-crimson-500',
        ],
      },
      disabled: {
        true: '',
      },
      isActive: {
        true: '',
      },
    },
    compoundVariants: [
      {
        disabled: true,
        theme: 'light',
        className: 'disabled:text-gray-200',
      },
      {
        disabled: true,
        theme: 'dark',
        className: 'disabled:text-gray-400',
      },
      {
        isActive: true,
        theme: 'light',
        className: 'text-gray-800',
      },
      {
        isActive: true,
        theme: 'dark',
        className: 'text-gray-50',
      },
    ],
  }
);
